// src/subscreens/Home/AboutSection.js
import React from 'react';
import '../../../assets/css/home/AboutSection.css';

const AboutSection = () => {
  return (
    <section className="as-about-section py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="as-about-image">
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop" 
                alt="Students studying together" 
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <h2 className="as-section-title mb-4">About CircleHub</h2>
            <p className="as-about-text">
              CircleHub is a modern group study platform designed to make learning easier, smarter, and more collaborative. 
              It helps students connect, share notes, summarize content using AI, participate in quizzes, and track their academic progress.
            </p>
            <p className="as-about-text">
              CircleHub focuses on teamwork, interactive learning, and performance improvement. Our mission is to empower students 
              with the tools they need to succeed together in their educational journey.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;